var niacs = {
    ModuleUrl: '/modules/custom/niacs_project_ui',
    INFO: false,
    LOG: false,
    DEBUG: false,
    FA_PREFIX: 'far',
    info: function() {
      if(niacs.INFO && console) {
        console.info.apply(null,arguments);
      }
    },
    log: function() {
      if(niacs.LOG && console) {
        console.log.apply(null,arguments);
      }
    },
    debug: function() {
      if(niacs.DEBUG && console) {
        if(console.debug) {
          console.debug.apply(null,arguments);
        } else {
          console.log.apply(null,arguments);
        }
      }
    },
    PROJECT_VERSION: '0.10',
    instructions: {
        'overview': 'OVERVIEW_INSTRUCTIONS',
        'units': 'STEP1A_INSTRUCTIONS',
        'goals': 'STEP1B_INSTRUCTIONS',
        'impacts': 'STEP2A_INSTRUCTIONS',
        'vulnerability': 'STEP2B_INSTRUCTIONS',
        'evaluate': 'STEP3_INSTRUCTIONS',
        'actions': 'STEP4A_INSTRUCTIONS',
        'recommendations': 'STEP4B_INSTRUCTIONS',
        'monitor': 'STEP5_INSTRUCTIONS',
        'export': 'EXPORT_INSTRUCTIONS'
    },
    menu: {
      'Progress Summary' : 'overview',
      'Step 1' : {
        'Define Management Topics' : 'units',
        'Management Goals and Objectives' : 'goals'
      },
      'Step 2' : {
        'Climate Impacts and Vulnerability' : 'impacts',
        'Vulnerability Determination' : 'vulnerability'
      },
      'Step 3' : {
        'Evaluate Objectives' : 'evaluate'
      },
      'Step 4' : {
        'Adaptation Actions' : 'actions',
        'Tactic Recommendations' : 'recommendations'
      },
      'Step 5' : {
        'Monitoring Plan' : 'monitor'
      },
      'Export and Share Plan' : 'export'
    },
    flattenMenu : function() {
        var label,item,nested_label,nested_menu,
            menuItems = [],
            menuItem,
            subItem;
        for(label in niacs.menu) {
            item = niacs.menu[label];
            if(angular.isObject(item)) {
                menuItems.push({label:label,item:null});
                for(nested_label in item) {
                    subItem = item[nested_label];
                    if(angular.isObject(subItem)) {
                      menuItems.push({label:nested_label,item:subItem.template,params:subItem.params});
                    } else {
                      menuItems.push({label:nested_label,item:subItem});
                    }
                }
            } else {
                menuItem = {label:label,item:item,nonStep: true};
                if(item.substring(0,1) == '-') {
                  menuItem.item = item.substring(1);
                  menuItem.render = false;
                }
                menuItems.push(menuItem);
            }
        }
        return menuItems;
    },
    assign: function(value,dflt) {
      return value ? value : dflt;
    },
    hashCode: function(str) {
      var hash = 0, i, chr, len;
      if (str.length === 0) { return hash; }
      for (i = 0, len = str.length; i < len; i++) {
        chr   = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return hash;
    },
    guid: (function() { // from stack overflow post
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
                   .toString(16)
                   .substring(1);
      }
      return function() {
        /* only needs to remain unique within a single project, and then technically
           really only within the list where it lives so a full length guid is
           over-kill and only serves to increase the size of a project payload.
           while one randomly generated set of 4 hex digits should do, two had
           better be.
        var guid = s4() + s4() + '-' + s4() + '-' + s4() + '-' +
               s4() + '-' + s4() + s4() + s4();
        */
       var guid = s4() + '-' + s4();
        return guid;
      };
    })(),
    resourceCoerce: function(obj,Clazz) {
console.warn('resourceCoerce called');
      var result = angular.isArray(obj) ? [] : new Clazz(obj);
      if(angular.isArray(obj)) {
        angular.forEach(obj,function(o) {
          result.push(new Clazz(o));
        });
      }
      return result;
    },
    /**
     * Tests whether an object is "custom" this is determined by whether it
     * has a string id, numeric ids being reserved for server side entities.
     *
     * @param  {Object}  o The object to test.
     * @return {Boolean}   True if it is a custom object.
     */
    isCustomObject: function(o) {
      return o && o.id && angular.isString(o.id);
    },
    isEmpty: function(str) {
      return (!str || str.length === 0 || str.trim().length === 0);
    },
    isEmptyObject: function(obj) {
      if(!obj) {
        return true;
      }
      var keyCnt = 0,key;
      for(key in obj) {
        if(key.substring(0,1) == '$') {
          continue; // ignore non-data
        }
        if(angular.isArray(obj[key])) {
          // ignore empty arrays
          if(obj[key].length > 0) {
            keyCnt++;
          }
        } else if(angular.isString(obj[key])) {
          // ignore empty strings
          if(!niacs.isEmpty(obj[key])) {
            keyCnt++;
          }
        } else {
          keyCnt++;
        }
      }
      return keyCnt === 0;
    },
    containsObjWithId: function(arr,id) {
      if(arr){
        for(var i = 0; i < arr.length; i++) {
          if(arr[i].id == id) {
            return true;
          }
        }
      }
      return false;
    },
    findById: function(arr,id) {
      for(var i = 0; arr && i < arr.length; i++) {
        if(arr[i].id == id) {
          return arr[i];
        }
      }
      return null;
    },
    removeById: function(arr,id) {
      var idx = -1,i;
      for(i = 0; i < arr.length; i++ ) {
          if(id == arr[i].id) {
              idx = i;
              break;
          }
      }
      if(idx >= 0) {
          arr.splice(idx,1);
      }
      return idx >= 0;
    },
    htmlToText: function(html) {
      if(html) {
        html = html.trim();
        if(html.indexOf("<p>") === 0) {
            html = html.substring(3);
        }
        if(html.length > 4 && html.substring(html.length-4) == '</p>') {
            html = html.substring(0,html.length-4);
        }
        html = html.replace(/\s*<br\s*\/>\s*/g,"\n").replace(/&nbsp;/g,' ');
      }
      return html;
    },
    isPredefined: function(obj) {
      return typeof(obj.id) == 'number';
    },
    endsWithId: function(s) {
      return s.match(/\.\d*$/) || s.match(/\.[a-f0-9]{4}-[a-f0-9]{4}$/);
    },
    collectGoals: function(hasGoals,includeUnits) {
      if(!hasGoals) {
        return [];
      }
      var units = [];
      // when properties started to no longer have objectives this means
      // that a project (only object with .units) only has goals that are references
      // that are then duplicated as references onto a project's units so exclude
      // a project's goals.
      if(includeUnits) {
        if(hasGoals.units) {
          units = hasGoals.units;
        }
      } else {
        units = [hasGoals];
      }
      return units.reduce(
        function(goals,context,i,a) {
          return context.goals ? goals.concat(context.goals) : goals;
        }, []);
    },
    countGoals: function(hasGoals,includeUnits) {
      return niacs.collectGoals(hasGoals,includeUnits).length;
    },
    /**
     * Collects objectives and if possible sets $sourceLabel to the label
     * of the context where the objective was collected from.
     *
     * @param  {Object} hasGoals     The goal container.
     * @param  {Boolean}  includeUnits Set to true if calling with the project (fetch objectives off of all units).
     * @return {Array}               List of objectives.
     */
    collectObjectives: function(hasGoals,includeUnits) {
      if(!hasGoals) {
        return [];
      }
      /* this was more concise but the context of where a specific objective
       * originated from is then lost
      return niacs.collectGoals(hasGoals,includeUnits).reduce(
        function(objectives,goal,i,a) {
          return goal.objectives ? objectives.concat(goal.objectives) : objectives;
        },[]);
      */
      var units = [];
      if(includeUnits) {
        if(hasGoals.units){
          units = hasGoals.units;
        }
      } else {
        units = [hasGoals];
      }
      return units.reduce(function(objectives,context){
        if(context.goals) {
          context.goals.forEach(function(goal){
            if(goal.objectives){
              goal.objectives.forEach(function(objective){
                // this logic is suspect since it relies on the caller having
                // "inflated" units so that pre-defined ones have $label set.
                objective.$sourceLabel = context.label||context.$label;
              });
              objectives = objectives.concat(goal.objectives);
            }
          });
        }
        return objectives;
      }, []);

    },
    countObjectives: function(hasGoals,includeUnits) {
      return niacs.collectObjectives(hasGoals,includeUnits).length;
    },
    countClimateImpacts: function(context,includeUnits) {
        var count = 0,i;
        if(context && context.cistatements) {
            count += context.cistatements.length;
        }
        if(context && includeUnits && context.units) {
            for(i = 0; i < context.units.length; i++) {
                if(context.units[i].cistatements) {
                    count += context.units[i].cistatements.length;
                }
            }
        }
        return count;
    },
    // utility method for "safe" dialogs that given a set of objectives
    // adds some info about nested objective details
    addSafeDeleteCounts: function(objectives,dialogContents) {
      function countEvalDetails(objectives) {
        return objectives.reduce(
          function(count,objective,i,a){
              return !niacs.isEmptyObject(objective.evaluate) ? (count+1) : count;
          },0);
      }
      function countTactics(objectives) {
        return objectives.reduce(
          function(count,objective,i,a){
              return objective.tactics && objective.tactics.length ? (count+1) : count;
          },0);
      }
      function countMonitoringPlans(objectives) {
        return objectives.reduce(
          function(count,objective,i,a){
              return !niacs.isEmptyObject(objective.monitor) ? (count+1) : count;
          },0);
      }
      var cnt;
      if((cnt=countEvalDetails(objectives)) > 0) {
        dialogContents.conditions.push(cnt + ' objectives have evaluation details supplied.');
      }
      if((cnt=countTactics(objectives)) > 0) {
        dialogContents.conditions.push(cnt + ' objectives have selected at least one adaptation tactic.');
      }
      if((cnt=countMonitoringPlans(objectives)) > 0) {
        dialogContents.conditions.push(cnt + ' objectives have monitoring plans supplied.');
      }
    },
    menuSteps: { // unfortunate but easier than re-working the menu, for now.
      'units': 'Step 1.1',
      'goals': 'Step 1.2',
      'impacts': 'Step 2.1',
      'vulnerability': 'Step 2.2',
      'evaluate': 'Step 3.1',
      'actions': 'Step 4.1',
      'monitor': 'Step 5.1'
    },
    getResourceFilter: function(context,project) {
        var params = {};
        if(context && context.vuln_region) { // project
          project = context;
          params['filter[field_resource_region.drupal_internal__nid][value]'] = context.vuln_region;
        } else if ( typeof(context) === 'string' && niacs.menuSteps[context]) { // step
          params['filter[field_resource_step.name][value]'] = niacs.menuSteps[context];
        }
        if(Object.keys(params).length && project && project.strategy_sources && project.strategy_sources.length) {
          params['filter[sector-filter][condition][path]'] = 'field_applicable_sectors.field_taxonomy_machine_name';
          params['filter[sector-filter][condition][operator]'] = 'IN';
          project.strategy_sources.forEach(function(s,i) {
            params['filter[sector-filter][condition][value]['+i+']'] = s;
          });
        }
        return Object.keys(params).length ? params : null;
    },
    mimeTypeIcons: {
      'application/pdf': 'file-pdf',
      'application/msword': 'file-word',
      'image/png': 'file-image',
      'image/jpeg': 'file-image',
      'image/gif': 'file-image',
      'text/plain': 'file-alt',
    },
    getFileTypeIcon: function(mimetype) {
      if(mimetype) {
        var type = mimetype.toLowerCase();
        if(type.length > 5 && type.substring(0,5) === 'image') {
          return 'file-image';
        } else if (type.length > 4 && type.substring(0,4) === 'text') {
          return 'file-alt';
        } else if (niacs.mimeTypeIcons[type]) {
          return niacs.mimeTypeIcons[type];
        }
      }
      return 'file';
    },
    INCOMPLETE: 'incomplete',
    COMPLETE: 'complete',
    PARTIAL_COMPLETE: 'partialComplete',
    testCompleteness: function(arr) {
      return arr.every(function (e,i,a) {return e === niacs.COMPLETE;}) ?
        niacs.COMPLETE :
        arr.some(function (e,i,a) {return e === niacs.COMPLETE || e === niacs.PARTIAL_COMPLETE;}) ?
          niacs.PARTIAL_COMPLETE : niacs.INCOMPLETE;
    },
    testObjectCompleteness: function(obj,fields) {
      if(!obj) {
        return niacs.INCOMPLETE;
      }
      return niacs.testCompleteness(fields.map(function(field) {
        var v = obj[field];
        return angular.isArray(v) ?
          (v.length > 0) ? niacs.COMPLETE : niacs.INCOMPLETE : // empty arrays are incomplete
          (v) ? niacs.COMPLETE : niacs.INCOMPLETE;
      }));
    },
    /**
     * Given adaptive capacity and potential impacts returns the vulnerability index
     * which is 0,1 or 2 for L,M,H respectively.  Valid values for ac/pi are 0,25,50,75,100
     * only.
     *
     * @param  {[type]} ac [description]
     * @param  {[type]} pi [description]
     * @return {[type]}    [description]
     */
    vulnerabilityIndex: function(ac,pi) {
      // the vulnerability taxonomy MUST be ordered L,M,H
      var low = 0,mod = 1,high = 2,
      vulnerability_plot = [
        [mod,mod,high,high,high],
        [mod,mod,mod,high,high],
        [low,mod,mod,mod,high],
        [low,low,mod,mod,mod],
        [low,low,low,mod,mod]
      ],
      range = [0,25,50,75,100];
      return vulnerability_plot[range.indexOf(ac)][range.indexOf(pi)];
    },
    migrateProject: function(p) {
        if(p.version != niacs.PROJECT_VERSION) {
          var origVersion = p.version;
          while(p.version != niacs.PROJECT_VERSION) {
            var migrator = niacs.migrators['m'+p.version.replace(/\./g, '_')];
            if(!migrator) {
                throw new Error("Property "+p.label+" Require migration but unable to find migrator for version "+p.version);
            }
            migrator(p);
          }
          return {
              orig: origVersion,
              destination: p.version
          };
        }
        return false;
    },
    migrators: {
      'm0_1': (function() { /* migrates v0.1 projects to v0.2 */
        function processGoalHolder(holder) {
          angular.forEach(holder.goals,function(goal){
            angular.forEach(goal.objectives,function(objective){
              if(objective.challenges || objective.opportunities ||
                 objective.feasibility || objective.feasibility_comments || objective.considerations) {
                if(console) {
                  console.log("objective '"+objective.id+"' requires upgrade.");
                }
                objective.evaluate = {};
                if(objective.challenges) {
                  objective.evaluate.challenges = objective.challenges;
                  delete objective.challenges;
                }
                if(objective.opportunities) {
                  objective.evaluate.opportunities = objective.opportunities;
                  delete objective.opportunities;
                }
                if(objective.feasibility) {
                  objective.evaluate.feasibility = objective.feasibility;
                  delete objective.feasibility;
                }
                if(objective.feasibility_comments) {
                  objective.evaluate.feasibility_comments = objective.feasibility_comments;
                  delete objective.feasibility_comments;
                }
                if(objective.considerations) {
                  objective.evaluate.considerations = objective.considerations;
                  delete objective.considerations;
                }
              }
            });
          });
        }
        return function(p) {
          processGoalHolder(p);
          angular.forEach(p.units,function(unit){
            processGoalHolder(unit);
          });
          p.version = "0.2";
        };
      })(),
      'm0_2': (function() { /* migrates v0.2 projects to v0.3 */
        function processGoalHolder(p,holder) {
          angular.forEach(holder.goals,function(goal){
            angular.forEach(goal.objectives,function(objective){
              if(objective.approaches) {
                angular.forEach(objective.approaches,function(approach){
                  // translate approach details into a tactic
                  var tactic = angular.extend({},approach);
                  tactic.approach = tactic.id;
                  tactic.id = niacs.guid();
                  delete tactic.recommended;
                  // NOTE: removing "empty" tactics
                  // i.e. "I recommend this approach but have supplied no tactic details."
                  // The v0.2 UI would allow it, but the v0.3 UI does not.
                  var ttest = angular.extend({},tactic);
                  delete ttest.id;
                  delete ttest.approach;
                  delete ttest.strategy;
                  if(niacs.isEmptyObject(ttest)) {
                    if(console) {
                      console.log("found empty approach in old project, skipping.");
                    }
                  } else {
                    if(!p.tactics) {
                      p.tactics = [];
                    }
                    p.tactics.push(tactic);
                    if(typeof(approach.recommended) == 'boolean') {
                      // if explicitly recommended or not translate that into a
                      // tactic ref.
                      if(!objective.tactics) {
                        objective.tactics = [];
                      }
                      objective.tactics.push({id: tactic.id, recommended: approach.recommended});
                    }
                  }
                });
              }
              delete objective.approaches;
            });
          });
        }
        return function(p) {
          processGoalHolder(p,p);
          angular.forEach(p.units,function(unit){
            processGoalHolder(p,unit);
          });
          p.version = "0.3";
        };
      })(),
      'm0_3': (function() { /* migrates v0.3 projects to v0.4 */
        function processGoalHolder(p,holder) {
          angular.forEach(holder.goals,function(goal){
            angular.forEach(goal.objectives,function(objective){
              if(objective.tactics) {
                var ntactics = [];
                angular.forEach(objective.tactics,function(tacticRef){
                  if(tacticRef.recommended) {
                    tacticRef.applicable = true;
                    ntactics.push(tacticRef);
                  }
                });
                if(ntactics.length === 0) {
                  delete objective.tactics;
                } else {
                  objective.tactics = ntactics;
                }
              }
            });
          });
        }
        return function(p) {
          processGoalHolder(p,p);
          angular.forEach(p.units,function(unit){
            processGoalHolder(p,unit);
          });
          p.version = "0.4";
        };
      })(),
      'm0_4': (function() { /* migrates v0.4 projects to v0.5 */
        return function(p) {
          delete p.vulnerability;
          if(p.goals) {
            angular.forEach(p.goals,function(g) {
              delete g.objectives;
            });
          }
          p.version = "0.5";
        };
      })(),
      'm0_5': (function() { /* migrates v0.5 projects to v0.6 */
        return function(p) {
          if(p.tactics) {
            angular.forEach(p.tactics,function(t) {
              t.approaches = [{
                strategy: t.strategy,
                approach: t.approach
              }];
              delete t.strategy;
              delete t.approach;
            });
          }
          p.version = "0.6";
        };
      })(),
      'm0_6': (function() { /* migrates v0.6 projects to v0.7 */
        return function(p) {
          angular.forEach(p.units,function(unit){
            angular.forEach(unit.goals,function(goal){
              angular.forEach(goal.objectives,function(objective){
                if(objective.monitor){
                  var mon = objective.monitor,
                      vari = mon.item;
                  if(mon.metr) {
                    vari = vari ? (vari + ' '+mon.metr) : mon.metr;
                  }
                  if(vari) {
                    mon.vari = vari;
                  }
                  delete mon.item;
                  delete mon.metr;
                }
              });
            });
          });
          p.version = "0.7";
        };
      })(),
      'm0_7': (function() { /* migrates v0.7 projects to v0.8 */
        return function(p) {
          angular.forEach(p.units,function(unit){
            // could be complicated and round, etc. but simply reset any
            // vulnerability related fields
            delete unit.vulnerability;
            delete unit.adaptive_capacity;
            delete unit.potential_impacts;
          });
          p.version = "0.8";
        };
      })(),
      'm0_8': (function() { /* migrates v0.8 projects to v0.9 */
        return function(p) {
          if(p.units) {
            angular.forEach(p.units,function(unit){
              if(unit.goals) {
                angular.forEach(unit.goals,function(goal){
                  if(goal.objectives) {
                    angular.forEach(goal.objectives,function(objective){
                      var monitor = objective.monitor;
                      delete objective.monitor;
                      if(monitor && !niacs.isEmptyObject(monitor)) {
                        monitor.id = niacs.guid();
                        objective.monitor = [{id: monitor.id,applicable: true}];
                        if(!p.monitor) {
                          p.monitor = [];
                        }
                        p.monitor.push(monitor);
                      }
                    });
                  }
                });
              }
            });
          }
          p.version = "0.9";
        };
    })(),
        'm0_9': (function(){
            return function(p) {
                p.strategy_sources = ['niacs_strategy'];
                p.version = '0.10';
            };
        })()

    }
};
